import { Form, Grid, useForm } from '@gcl/react-core';
import { DisplayWrapper } from '@core/DisplayWrapper/DisplayWrapper';
import { DEFAULT_TABLE_PAGE_SIZE } from '@common/constants';
import { ApiErrorDisplay } from '@core/ApiErrorDisplay';
import { useFetchUserPreferences } from './userProfilePreferences.queries';
import { IUserProfilePreferences } from './userProfilePreferences.models';
import { SettingUserPreferenceRow } from './SettingUserPreferenceRow';
import { EUserProfilePreferenceType } from './userProfilePreferences.constants';

export const SettingUserPreferenceTab = () => {
  const useFormMethods = useForm({
    mode: 'onBlur',
    shouldFocusError: true,
  });
  const {
    data: dataUserPreferences,
    isLoading: isLoadingUserPreference,
    error: errorUserPreference,
  } = useFetchUserPreferences();

  const getDefaultFormValues = (dataUserPreferencesLocal: IUserProfilePreferences[]) => {
    let state: { [key: string]: any } = {};

    dataUserPreferencesLocal.map((item) => {
      let value: any;
      if (item.preference.attributeType === EUserProfilePreferenceType.BOOLEAN) {
        value = !!(item.value && item.value.toLowerCase() === 'true');
      } else if (item.preference.attributeType === EUserProfilePreferenceType.PAGE_SIZE_DROPDOWN) {
        const tempValue = item.value && item.value !== 'undefined' ? Number(item.value) : DEFAULT_TABLE_PAGE_SIZE;
        value = { key: tempValue, text: tempValue, data: tempValue };
      }
      state = {
        ...state,
        [item.id]: value ?? item.value,
      };
    });

    return state;
  };
  return (
    <>
      <ApiErrorDisplay errors={[{ error: errorUserPreference, genericError: 'Get user preference failed' }]} />
      <DisplayWrapper
        isLoading={isLoadingUserPreference}
        loaderProps={[
          { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 20 },
          { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 350 },
          { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 300 },
          { suffixBlankRow: true, numberOfRows: 1, lineHeight: 20, lineWidth: 320 },
        ]}
      >
        <Form
          useFormMethods={useFormMethods}
          defaultValues={{
            callback: () => {
              const state = getDefaultFormValues(dataUserPreferences?.items ?? []);
              return state;
            },
            deps: [dataUserPreferences?.items],
          }}
          render={(formFieldMethods) => {
            return (
              <Grid container spacing={2}>
                {dataUserPreferences?.items?.map((item) => {
                  return <SettingUserPreferenceRow item={item} formFieldMethods={formFieldMethods} key={item.id} />;
                })}
              </Grid>
            );
          }}
        />
      </DisplayWrapper>
    </>
  );
};
